/* eslint-disable no-unused-vars */
import React, { useCallback, useContext, useMemo, useState } from 'react'
import {
  getApiTargetInfo,
  getUnitNameMap,
  getUnits,
  getUtilities,
  getUtilityNameMap,
  getUtilityUnitsMap,
} from 'core'
import { connect } from 'react-redux'
// import R from 'ramda'
// import { UtilityUnitSelection } from 'core/component/UtilityUnitSelection'
// import { marginPnodeZone } from 'api/pgads'
// eslint-disable-next-line no-unused-vars
import { MarginAnalysisPNodeZoneContext, PNodeZoneContext } from 'context'
import { Cascader } from 'antd'
import R from 'ramda'
import { getClientInfo } from '../core/selectors'
import { CPS_CLIENT } from '../client'

const MarginAnalysisUtilityUnitSelection = props => {
  const {
    utility,
    unit,
    utilityNameMap,
    coreUnitNameMap,
    // utilityUnitMap,
    onUnitChange,
    utilities,
    units,
    CLIENT,
    // apiTargetInfo,
    showX2X3 = false,
    ...etcProps
  } = props

  const { emktUnits, marginUnitsList, unitIdEmktIdMap } = useContext(
    PNodeZoneContext
  )
  // const { marginUnitsList } = useContext(MarginAnalysisPNodeZoneContext)

  const rollUnitNameMap = R.compose(
    R.fromPairs,
    R.map(u => [u.unitId, u.rollupEmktid]),
    R.filter(m => m.utilityRollupId)
  )(marginUnitsList)

  const unitNameMap = useMemo(
    _ => ({ ...coreUnitNameMap, ...rollUnitNameMap }),
    [coreUnitNameMap, rollUnitNameMap]
  )

  // const activeUnitsList = marginUnitsList.map(u => u.unitId)

  const utilityUnitMap = R.reduceBy(
    (acc, { unitId }) => acc.concat(unitId),
    [],
    u => u.utility,
    marginUnitsList
  )

  const utilityIds = useMemo(_ => (utilities || []).map(u => u.utility), [
    utilities,
  ])
  const utilitysortOpt = useCallback(
    (a, b) => {
      return (utilityNameMap[a] || a).localeCompare(utilityNameMap[b] || b)
    },
    [utilityNameMap]
  )
  const unitsortOpt = useCallback(
    (a, b) => {
      const val = (unitNameMap[a] ? unitNameMap[a] : a || '')
        .toLowerCase()
        .localeCompare(
          (unitNameMap[b] ? unitNameMap[b] : b || '').toLowerCase()
        )

      return val
    },
    [unitNameMap]
  )

  // const activeUnits = useMemo(_ => marginUnitsList.map(u => u.unitId), [
  //   marginUnitsList,
  // ])

  const [defValue, setValue] = useState(unit == null ? [] : [utility, unit])

  let cascaderOptions = useMemo(
    _ =>
      R.uniq(R.sort(utilitysortOpt, Object.keys(utilityUnitMap)))
        // .sort((a, b) => utilityNameMap[a].localeCompare(utilityNameMap[b]))
        .filter(k => utilityIds.includes(k))
        .map(ut => {
          const childrenMain = R.uniq(
            R.sort(unitsortOpt, R.uniq(utilityUnitMap[ut] || []))
            // R.uniq(utilityUnitMap[ut] || [])
          )

            .map(u => marginUnitsList.find(mu => u === mu.unitId))
            .filter(u => u)
            .map(un => ({
              isCC: un.id1 === 'CC',
              value: un.utilityRollupId ? un.utilityRollupId : un.unitId,
              unitName:
                unitNameMap[un.unitId] || un.utilityRollupId || un.unitId,
              key: un.utilityRollupId ? un.utilityRollupId : un.unitId,
              label: un.utilityRollupId
                ? un.rollupEmktid + ' (' + un.utility + '-000)'
                : (unitNameMap[un.unitId] || un.unitId) +
                  ' ( ' +
                  ut +
                  '-' +
                  un.unit +
                  ' )',
            }))

          let byX2X3 = []
          if (CLIENT === CPS_CLIENT && showX2X3) {
            byX2X3 = R.compose(
              R.flatten,
              R.map(cc => [
                {
                  value: unitIdEmktIdMap[cc.value] + 'X2',
                  key: unitIdEmktIdMap[cc.value] + 'X2',
                  label: unitIdEmktIdMap[cc.value] + 'X2',
                  unitName: unitIdEmktIdMap[cc.value] + 'X2',
                },
                {
                  value: unitIdEmktIdMap[cc.value] + 'X3',
                  key: unitIdEmktIdMap[cc.value] + 'X3',
                  label: unitIdEmktIdMap[cc.value] + 'X3',
                  unitName: unitIdEmktIdMap[cc.value] + 'X3',
                },
              ]),
              R.filter(cc => cc.isCC)
            )(childrenMain)
          }
          const children = R.sortBy(u => u.unitName, [
            ...byX2X3,
            ...childrenMain,
          ])

          return {
            value: ut,
            key: ut,
            label: utilityNameMap[ut] + ' (' + ut + ')',
            children,
            // children: [...byX2X3, ...children],
            // children: sortData,
            disabled: children.length <= 0,
          }
        }),
    [
      utilitysortOpt,
      utilityUnitMap,
      utilityIds,
      unitsortOpt,
      CLIENT,
      showX2X3,
      utilityNameMap,
      marginUnitsList,
      unitNameMap,
      unitIdEmktIdMap,
    ]
  )
  const allCas = useMemo(
    _ => {
      const childrenMain = R.sort(
        unitsortOpt,
        marginUnitsList.map(u => u.unitId) || []
      )
        .map(u => marginUnitsList.find(un => u === un.unitId))
        .filter(k => utilityIds.includes(k.utility))
        .map(u => ({
          isCC: u.id1 === 'CC',
          value: u.utilityRollupId || u.unitId,
          unitName: unitNameMap[u.unitId] || u.utilityRollupId || u.unitId,
          key: u.utilityRollupId || u.unitId,
          label: u.rollupEmktid
            ? u.rollupEmktid + ' (' + u.utility + '-000)'
            : unitNameMap[u.unitId] + ' (' + u.unitId + ')',
          // label: unitNameMap[u.unitId] + ' (' + u.unitId + ')',
        }))
      let byX2X3 = []
      if (CLIENT === CPS_CLIENT && showX2X3) {
        byX2X3 = R.compose(
          R.flatten,
          R.map(cc => [
            {
              value: unitIdEmktIdMap[cc.value] + 'X2',
              key: unitIdEmktIdMap[cc.value] + 'X2',
              label: unitIdEmktIdMap[cc.value] + 'X2',
              unitName: unitIdEmktIdMap[cc.value] + 'X2',
            },
            {
              value: unitIdEmktIdMap[cc.value] + 'X3',
              key: unitIdEmktIdMap[cc.value] + 'X3',
              label: unitIdEmktIdMap[cc.value] + 'X3',
              unitName: unitIdEmktIdMap[cc.value] + 'X3',
            },
          ]),
          R.filter(cc => cc.isCC)
        )(childrenMain)
      }
      const children = R.sortBy(u => u.unitName, [...byX2X3, ...childrenMain])

      return {
        label: 'ALL',
        value: 'ALL',
        children,
      }
    },
    [
      CLIENT,
      marginUnitsList,
      showX2X3,
      unitIdEmktIdMap,
      unitNameMap,
      unitsortOpt,
      utilityIds,
    ]
  )

  cascaderOptions = useMemo(_ => [allCas, ...cascaderOptions], [
    allCas,
    cascaderOptions,
  ])

  return (
    <Cascader
      defaultValue={defValue}
      value={unit == null ? [] : defValue}
      style={{ width: '90%', alignSelf: 'center' }}
      options={cascaderOptions}
      onChange={value => {
        setValue(value)
        if (value[0] === 'ALL' && value[1])
          onUnitChange([value[1].substring(0, 3), value[1]])
        else onUnitChange(value)
      }}
      allowClear={false}
      {...etcProps}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  coreUnitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  utilities: getUtilities(state),
  units: getUnits(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(MarginAnalysisUtilityUnitSelection)
